export const WELLNESS_OPTIONS = [
	{ optionId: 1, annual: 0, monthly: '', isVisible: true },
	{ optionId: 91, annual: 300,  monthly: '$22.92 /month', isVisible: true },
	{ optionId: 92, annual: 500,  monthly: '$39.58 /month', isVisible: true },
	{ optionId: 93, annual: 700,  monthly: '$56.25 /month', isVisible: true },
	{ optionId: 15, annual: 250,  monthly: '$18.75 /month', isVisible: false },
	{ optionId: 35, annual: 450,  monthly: '$35.42 /month', isVisible: false },
	{ optionId: 55, annual: 650,  monthly: '$52.09 /month', isVisible: false },
];

export type WellnessOption = {
	optionId: number;
	annual: number;
	monthly: string;
	isVisible: boolean;
};
